// src/i18n/locales/de.ts
export default {
  consent: {
    title: 'Wir schätzen Ihre Privatsphäre',
    descriptionStart: 'Wir verwenden Tracking-Technologien, um Ihre Erfahrung zu verbessern und zu analysieren, wie Sie unseren Service nutzen. Indem Sie auf "Akzeptieren" klicken, stimmen Sie der Verwendung dieser Technologien zu. Lesen Sie unsere ',
    privacyLinkText: 'Datenschutzerklärung',
    descriptionEnd: ' für weitere Details.',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
  }
}